import {IItemContent} from "@connox/typescript-library";
import React, {Suspense, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import {paMainUrl, retrieveItemContent} from "./CrossSelling";
import {useCustomerSelector} from "../../../store";
import {useTranslation} from "react-i18next";
import ErrorBoundary from "../../utils/ErrorBoundary";
import SwiperConstruct from "./SwiperConstruct";
import ListItemCard from "../productList/ListItemCard";

type ConfigDataType = {c: string};
type PaLocalStorageType = {configData: ConfigDataType};
type PatutilType = {paLocalStorage: PaLocalStorageType};
declare global {
  interface Window {
    patutil: PatutilType | undefined;
  }
}
// Reference to the legacy code, where we have a cookie reader
declare const c: {
  sessionCookie: {
    get: (key: string) => string | false;
  };
};

export const getPACustomerId = () => {
  try {
    // When customer rejects the cookies, there will be no `window.patutil`
    // All else cases would be an error on PA side
    return window.patutil?.paLocalStorage.configData.c;
  } catch (e) {
    const customerId = c.sessionCookie.get("PAC");
    if (__DEVELOPMENT__) {
      /* eslint-disable no-console */
      console.log("DEVELOPMENT:");
      console.log("PAC:", customerId, ", typeof:", typeof customerId);
      console.log(e);
      /* eslint-enable no-console */
    }
    // No idea what this means, but maybe a chrome bug?
    if (customerId === "undefined") {
      return false;
    }

    return customerId;
  }
};

// Empfehlungen für Sie
const RecommendationsPortalComponent: React.FC = () => {
  const {t} = useTranslation();
  const {customer} = useCustomerSelector();
  const [items, setItems] = useState<IItemContent[]>([]);

  useEffect(() => {
    let paUrl = paMainUrl;
    const paCustomerId = getPACustomerId();
    if (paCustomerId) {
      // https://docs.particularaudience.com/api-definitions/personalized-recommendations
      paUrl += `Personalized?customerId=${paCustomerId}`;
    } else {
      // https://docs.particularaudience.com/api-definitions/popular-items
      paUrl += "PopularItems";
    }
    void retrieveItemContent(paUrl, customer).then(setItems);
  }, []);

  if (!items.length) {
    return null;
  }

  return (
    <SwiperConstruct title={t("product.recommendationsForYou")}>
      {items.map((itm, key) => {
        return <ListItemCard key={key} item={itm} />;
      })}
    </SwiperConstruct>
  );
};

const RecommendationsPortal: React.FC = () => {
  const parentCategoriesElement = document.getElementById("PARecommendations");

  if (!parentCategoriesElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <ErrorBoundary fallback={null} occurrence="RecommendationsPortal">
      <Suspense fallback={null}>
        <RecommendationsPortalComponent />
      </Suspense>
    </ErrorBoundary>,
    parentCategoriesElement,
  );
};

export default RecommendationsPortal;
